import React from "react";
import { labels } from "../../../../localization/labels";
import ButtonBar from "../../../core/ButtonBar/ButtonBar";
import ComponentHeader from "../../../core/ComponentHeader";
import ClassificationSelection from "../../page/ClassificationSelection";

const ClassificationPartySubscriptions = ({ onSave, ...selectionProps }) => {
  return (
    <div className="container">
      <div className="tabVerticalSize" />
      <div className="containerShadow">
        <div>
          <ComponentHeader
            title={labels.classificationSubscriptions}
            showBackButton
          />
        </div>
        <div className="bordered_bottom_rounded">
          <ClassificationSelection {...selectionProps} />
          <ButtonBar onSave={onSave} />
        </div>
      </div>
    </div>
  );
};

export default ClassificationPartySubscriptions;
